var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error429"},[_c('errorItem',{attrs:{"data":_vm.data}},[_c('img',{attrs:{"src":require("@/assets/images/429.jpg")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }